export type AuthStatus = 'None' | 'MsalAuthSuccess' | 'MsalAuthError';

let authStatus: AuthStatus = 'None';
let authError: string = '';
let fromCache: boolean | undefined;
let pageVisible: boolean | undefined;
let authErrorDetails:
    | {
          errorMessage: string;
          subError: string;
          correlationId: string;
      }
    | undefined;

export function setAuthStatusInfo(
    msalAuthStatus: AuthStatus,
    correlationId: string,
    errorCode?: string,
    errorMessage?: string,
    subError?: string,
    cache?: boolean,
    pageAlwaysVisible?: boolean
): void {
    authStatus = msalAuthStatus;
    fromCache = cache;
    pageVisible = pageAlwaysVisible;
    if (errorCode && errorMessage && subError) {
        authError = errorCode;
        authErrorDetails = {
            errorMessage,
            subError,
            correlationId,
        };
    }
}

export interface AuthStatusInfo {
    authStatus: AuthStatus;
    authError: string;
    fromCache: boolean | undefined;
    pageVisible: boolean | undefined;
    authErrorDetails?: {
        errorMessage: string;
        subError: string;
        correlationId: string;
    };
}

export function getAuthStatusInfo(): AuthStatusInfo {
    return { authStatus, authError, fromCache, pageVisible, authErrorDetails };
}
